import { render } from "./TopSiteNavigation.vue?vue&type=template&id=603ba709"
import script from "./TopSiteNavigation.vue?vue&type=script&lang=ts"
export * from "./TopSiteNavigation.vue?vue&type=script&lang=ts"

import "./TopSiteNavigation.vue?vue&type=style&index=0&id=603ba709&lang=scss"
script.render = render

export default script